var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabs',{attrs:{"parent":"production"}},[_c('tab',{attrs:{"id":"order_list","name":_vm.translate('production.many'),"href":_vm.url+'/order_list'}},[_c('OrderList')],1),_c('tab',{attrs:{"id":"specifications","name":_vm.translate('production_plan.many'),"href":_vm.url+'/specifications'}},[_c('Specifications')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }